export default __webpack_public_path__ + "static/media/3051.03f26b09.jpg";